import {
    Alert,
    AlertType,
    Button,
} from '@cuatroochenta/co-admin-react-library';
import React, {useEffect, useState} from 'react';
import {BulletinSelectionService} from '../BulletinSelectionService';
import {
    useCustomButtonListBulletinController
} from '../useCustomButtonListBulletinController';
import {BulletinListFilters} from '../useBulletinListFilters';

interface Props {
    filtersRef: React.MutableRefObject<BulletinListFilters>;
}

export const CustomButtonListBulletin = ({filtersRef}: Props) => {
    const controller = useCustomButtonListBulletinController();
    const [selectedBulletinIds, setSelectedBulletinIds] = useState<string[]>([]);

    useEffect(() => {
        BulletinSelectionService.setUpdateCallback(setSelectedBulletinIds);
        setSelectedBulletinIds(BulletinSelectionService.getSelectedBulletinIds());

        return () => {
            BulletinSelectionService.setUpdateCallback(() => {});
        };
    }, []);

    return (
        <>
            <Alert show={!!controller.error} message={controller.error} type={AlertType.DANGER} />
            <Button onClick={() => controller.handleExportPdf(selectedBulletinIds, filtersRef.current)}
                    content={'Exportar PDF'}
                    />
            <Button onClick={() => controller.handleExportExcel(selectedBulletinIds, filtersRef.current)}
                    content={'Exportar Excel'}
            />
        </>
    );
};
